import React from "react";
import PropTypes from "prop-types";
import Cell from "./Cell";
import { Button, Space } from "antd";
import { MinusCircleFilled } from "@ant-design/icons";

const getRowOptions = (lprops, _id) => {
  if (
    lprops.indexOptions.find((pt) => pt._id === _id) !== undefined &&
    lprops.indexOptions.find((pt) => pt._id === _id).values !== undefined
  ) {
    return lprops.indexOptions.find((pt) => pt._id === _id).values;
  }
  return [];
};

function IndexRowGroups(props) {
  // console.log(props,'prp list')
  return props.list.map((el, index) => (
    <td
      key={index}
      style={{
        width: props.type === 2 && index === 0 ? 266 : 250,
        paddingLeft: props.type === 2 && index === 0 ? 16 : 0,
      }}
    >
      <div style={{ width: 250 }}>
        <Cell
          index={props.rowIndex}
          _id={el.uniqueId}
          value={el.value}
          // list={getRowOptions(props,el._id).map(rt=>{
          list={props.getIndexOptions(el.index_id, props.rowIndex).map((rt) => {
            return {
              _id: rt,
              name: rt,
            };
          })}
          updateDataRecord={props.updateDataRecord}
          // style={ props.list.length===index+1?{width:'200px'}:undefined}
        />
      </div>
      {/* style={{marginLeft:16,fontSize:16,color:'red'}} */}
    </td>
  ));
}

// IndexRowGroups.propTypes = {

// }

export default IndexRowGroups;
